import { ClubPointsBlock } from 'cms-types'
import { type LoadableComponentProps } from 'ui'

import { ClubPointsClient } from './ClubPointsClient'

function ClubPoints(props: LoadableComponentProps<ClubPointsBlock>) {
  return <ClubPointsClient {...props} />
}

export default ClubPoints
ClubPoints.loadable = true
